// Demonstrate the available swipe direction without changing the selected photo or scroll position.
document.addEventListener('shown.bs.modal', event => {
    const modal = event.target;
    const mobile = window.matchMedia('(max-width: 767.98px), (orientation: landscape) and (max-height: 600px) and (pointer: coarse)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!modal.matches('.photo-change-modal') || !mobile.matches || reducedMotion.matches) return;

    const gallery = modal.querySelector('.photo-selection-gallery');
    const cards = gallery?.querySelectorAll('.photo-in-list-button');
    const body = modal.querySelector('.modal-body');
    if (!body || !cards || cards.length < 2) return;

    const horizontal = gallery.scrollWidth > gallery.clientWidth + 1;
    const scroller = horizontal ? gallery : body;
    const position = horizontal ? scroller.scrollLeft : scroller.scrollTop;
    const maximum = horizontal
        ? scroller.scrollWidth - scroller.clientWidth
        : scroller.scrollHeight - scroller.clientHeight;
    if (maximum < 1) return;

    const galleryRect = gallery.getBoundingClientRect();
    const bodyRect = body.getBoundingClientRect();
    if (galleryRect.top >= bodyRect.bottom || galleryRect.bottom <= bodyRect.top) return;

    const distance = Math.min(48, maximum) * (position >= maximum - 1 ? 1 : -1);
    const transform = horizontal ? `translateX(${distance}px)` : `translateY(${distance}px)`;
    const animations = Array.from(cards, card => card.animate([
        { transform: 'translate(0)', offset: 0 },
        { transform, offset: 0.4 },
        { transform, offset: 0.6 },
        { transform: 'translate(0)', offset: 1 }
    ], { duration: 1000, delay: 200, easing: 'ease-in-out' }));

    const controller = new AbortController();
    const stop = () => {
        animations.forEach(animation => animation.cancel());
        controller.abort();
    };
    const options = { signal: controller.signal, passive: true };
    ['pointerdown', 'touchstart', 'wheel', 'keydown', 'hide.bs.modal'].forEach(type =>
        modal.addEventListener(type, stop, options));
    window.addEventListener('resize', stop, options);
    reducedMotion.addEventListener('change', stop, options);
    Promise.allSettled(animations.map(animation => animation.finished)).then(stop);
});
